<script>
  import { session, gameId, me, update } from "../store"
  import Shell from "./Shell.svelte"
  import Count from "./Count.svelte"
  import play from "../lib/play"
  import RoundStatus from "./RoundStatus.svelte"
  import punct from "../lib/punct"

  export let sentence = ""
  export let submissions = []
  export let blanks = []
  let parts = []
  let votes = []
  let timo = 0
  let fills = false
  let lastFills = false
  let lastSentence = false
  let voteCount = 0
  let myVote = false
  $: votes =
    $session && $session.votes[$session.onSentence]
      ? $session.votes[$session.onSentence]
      : {}
  $: voteCount = $session ? Object.values(votes).length : 0
  $: myVote = votes[$me.id]
  $: {
    if ($session && (sentence !== lastSentence || fills !== lastFills)) {
      let inx = 0
      let matches = sentence.match(punct)
      parts = sentence
        .replace(new RegExp(`[${matches[0].split("").join("\\")}]$`), "")
        .split(" ")
        .map(content => {
          if (content[0] === "%") {
            inx += 1
            return {
              content: fills
                ? fills[inx - 1]
                : blanks[+content.replace("%blank-", "")],
              type: "input"
            }
          }
          return {
            type: "word",
            content
          }
        })
      parts.push({ type: "word", content: matches[0] })
      lastFills = fills
      lastSentence = sentence
    }
  }
  function handleVote(key, val) {
    play("ding")
    update(`votes.${$session.onSentence}.%u`, key)
    fills = val.submission
  }
  function handleSelect(val) {
    clearTimeout(timo)
    fills = val.submission
  }
  function handleUnselect() {
    timo = setTimeout(() => {
      fills = myVote && submissions ? submissions[myVote].submission : false
    })
  }
</script>

<style lang="scss">
  @import "../vars";
  input {
    margin: 0 0.3rem;
  }
  .sentence {
    font-size: 1.3rem;
    text-align: center;
    background: l($gray, 60%);
    padding: 2rem;
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    line-height: 170%;
  }
  .options {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 1rem;
    margin-top: 1rem;
    @include below(bigphone) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .selected {
    background: $red;
    color: $white;
  }
  .filled {
    background: l($red, 90%);
    border: 1px dashed l($red, 70%);
    padding: 0.3rem 0.6rem;
    margin: 0 0.3rem 0 0.1rem;
    line-height: 130%;
  }
  h4 {
    margin-top: 3rem;
    margin-bottom: 0.4rem;
  }
  button {
    background: $gray;
    border: 0;
    padding: 0.6rem;
    display: block;
    cursor: pointer;
  }
</style>

<div>
  <h2>Submissions are in, now vote on your favorite!</h2>
  <Shell>
    <div class="sentence">
      {#each parts as word}
        {#if word.type === 'input'}
          <span class="filled">{word.content}</span>
        {:else}
          <span>{word.content}&nbsp;</span>
        {/if}
      {/each}
    </div>
    <h4>Click an Option to Vote:</h4>
    <div class="options">
      {#each Object.entries(submissions)
        .sort(([keyA, a], [keyB, b]) => {
          if (a.stamp.seconds < b.stamp.seconds) return -1
          if (a.stamp.seconds > b.stamp.seconds) return 1
          if (a.stamp.nanoseconds < b.stamp.nanoseconds) return -1
          if (a.stamp.nanoseconds > b.stamp.nanoseconds) return 1
          if (a.submission[0] < b.submission[0]) return -1
          if (a.submission[0] > b.submission[0]) return 1
        })
        .slice(0, $session.maxPerRound) as [key, val]}
        <button
          class:selected={key === myVote}
          on:mouseover={() => handleSelect(val)}
          on:mouseout={handleUnselect}
          on:click={() => handleVote(key, val)}>
          {val.submission.join(' | ')}
        </button>
      {/each}
    </div>
  </Shell>
  <RoundStatus>
    <div>
      {voteCount}
      <label>votes</label>
    </div>
    <Count />
  </RoundStatus>
</div>
